import gql from 'graphql-tag';
import { SECRETARY_OF_STATE_REPORT_FRAGMENT } from './fragments/secretaryOfStateReportFragment';

export const PULL_SECRETARY_OF_STATE_SEARCH_REPORT = gql`
  mutation PullSecretaryOfStateReport($input: PullSecretaryOfStateInput!) {
    cobaltIntelligence {
      result: pullSecretaryOfStateReport(input: $input) {
        error
        success
        entity {
          ...SecretaryOfStateReportViewModel
        }
      }
    }
  }
  ${SECRETARY_OF_STATE_REPORT_FRAGMENT}
`;
